import { mapActions } from 'vuex'
import SignInMixin from '@/store/module/signIn/mixin'
import { globalActions as authActions } from '@/store/module/auth/actionTypes'
import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'Authentication',
  data () {
    return {
      version: process.env.VersionApp,
      randomImage: '',
      // images: [
      //   'https://static.zopone.com.br/img/login1.jpg',
      //   'https://static.zopone.com.br/img/login2.jpg',
      //   'https://static.zopone.com.br/img/login3.jpg',
      //   'https://static.zopone.com.br/img/login4.jpg',
      //   'https://static.zopone.com.br/img/login5.jpg',
      //   'https://static.zopone.com.br/img/login6.jpg',
      //   'https://static.zopone.com.br/img/login7.jpg',
      //   'https://static.zopone.com.br/img/login8.jpg',
      //   'https://static.zopone.com.br/img/login9.jpg',
      //   'https://static.zopone.com.br/img/login10.jpg',
      //   'https://static.zopone.com.br/img/login11.jpg'
      // ]
      images: [
        'https://static.zopone.com.br/img/loginFinal.jpg'
      ]
    }
  },
  mixins: [
    SignInMixin
  ],
  mounted () {
    const idx = Math.floor(Math.random() * this.images.length)
    this.randomImage = `url("${this.images[idx]}")`
  },
  methods: {
    ...mapActions({
      signIn: authActions.SIGN_IN,
      fetchUserInfo: authActions.FETCH_USER_INFO
    }),
    validateAndSignIn () {
      this.$validator.validateAll()
        .then((valid) => {
          if (valid) {
            this.signIn(this.credentials)
              .then((success) => {
                if (success) {
                  this.fetchUserInfo()
                    .then(() => {
                      this.$router.push({ name: 'StartPage' })
                    })
                }
              })
              .catch((e) => {
                if (e.message === 'Not authorized') {
                  toast.error(this.$lang.Login.InvalidCredentials)
                } else {
                  toast.error(this.$lang.Login.ServiceOff)
                }
              })
          }
        })
    },
    getValidationState (fieldName) {
      const field = this.$validator.fields.find({ name: fieldName })

      if (!field) return null

      const isDirty = field.flags.dirty
      const isValid = !this.errors.has(fieldName)
      return isDirty ? isValid : null
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/public/auth/Authentication.js